"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactBootstrap = require("react-bootstrap");

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _ReportDetailAddEditTypeModal = require("./ReportDetailAddEditTypeModal");

var _ReportDetailAddEditTypeModal2 = _interopRequireDefault(_ReportDetailAddEditTypeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var ReportDetailAddTypeUncontrolledModal = function (_React$Component) {
    _inherits(ReportDetailAddTypeUncontrolledModal, _React$Component);

    function ReportDetailAddTypeUncontrolledModal(props) {
        _classCallCheck(this, ReportDetailAddTypeUncontrolledModal);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailAddTypeUncontrolledModal).call(this, props));

        _this.onHide = function () {
            _this.setState({
                showModal: false
            });
        };
        _this.onShow = function () {
            console.log("onShow");
            _this.setState({
                showModal: true
            });
        };
        _this.onSuccess = function (newInstanceUid) {
            // inform the controlling component about the new entry...
            _this.props.onSuccess(_this.props.dispatch, newInstanceUid);
            // close the modal!
            _this.onHide();
        };
        _this.state = {
            showModal: false
        };
        return _this;
    }

    _createClass(ReportDetailAddTypeUncontrolledModal, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var formatMessage = this.props.intl.formatMessage;

            if (this.props.nameSingular === null) {
                // invalid definition schema entry, show nothing.
                return null;
            }
            return React.createElement("div", { style: { paddingBottom: "10px", marginTop: -12 } }, React.createElement(_ReportDetailAddEditTypeModal2.default, { mode: "add", showModal: this.state.showModal, onClose: this.onHide, saveReportBeforeAddType: true, onSuccess: this.onSuccess, reportDataDefinitionUid: this.props.reportDataDefinitionUid }), React.createElement(_reactBootstrap.Button, { bsSize: "xsmall", onClick: function onClick() {
                    return _this2.onShow();
                }, bsStyle: "default", disabled: this.props.disabled }, React.createElement("i", { className: "fa fa-plus" }), " ", this.props.nameSingular, " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.empty.postfix" })));
        }
    }]);

    return ReportDetailAddTypeUncontrolledModal;
}(React.Component);
ReportDetailAddTypeUncontrolledModal = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {};
})], ReportDetailAddTypeUncontrolledModal);
exports.default = ReportDetailAddTypeUncontrolledModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailAddTypeUncontrolledModal.tsx
 ** module id = 1273
 ** module chunks = 0
 **/